import { FilterOptionButton } from '@/components/common/FilterButtons';

const procedureOptions = [
  { label: 'Add', value: 'add' },
  { label: 'Edit', value: 'edit' },
  { label: 'Delete', value: 'delete' },
];

export interface SupplementFilters {
  procedure?: string;
}

interface SupplementFiltersProps {
  filters: SupplementFilters;
  onFiltersChange: (filters: SupplementFilters) => void;
}

export function SupplementFilters({
  filters,
  onFiltersChange,
}: SupplementFiltersProps) {
  return (
    <div className="flex flex-row flex-wrap gap-4">
      {procedureOptions.map((option) => (
        <FilterOptionButton
          key={option.value}
          label={option.label}
          isActive={filters.procedure === option.value}
          onClick={() =>
            onFiltersChange({
              ...filters,
              procedure: option.value,
            })
          }
        />
      ))}
    </div>
  );
}
